import styled from "styled-components";
import {Quote, Person, StyledBaseProps} from "@betrue/shared/interfaces";
import { FileLink, INVOICE_INITIAL_STATE} from "@betrue/ui";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  InputAdornment,
  TextField
} from "@mui/material";
import * as React from "react";
import {useCallback, useState} from "react";
import {Controller, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {quoteFormValidationSchema, QuoteModalForm} from "./quote.form";
import Dropzone from 'react-dropzone'
import {AddQuoteProps} from "./add-quote";

interface AddQuoteViewProps extends StyledBaseProps, AddQuoteProps {
  onOpenModal: () => void,
  onCloseModal: () => void,
  onFileDrop: (file) => void
  onSubmit: (form: QuoteModalForm) => void
  quote: Quote
  isOpen: boolean
  enabled: boolean
  currentPerson: Person
  authorizeUrl: string
}

export const AddQuoteView = styled((props: AddQuoteViewProps) => {
  const {register, handleSubmit, control, formState: {errors}, reset} = useForm<QuoteModalForm>({
    resolver: yupResolver(quoteFormValidationSchema)
  })

  const [quoteFile, setQuoteFile] = useState(undefined)


  const onDrop = useCallback(dropped => {
    props.onFileDrop(dropped[0])
    // Do something with the files
  }, [])

  return (
    <div className={props.className}>
      <Grid container spacing={3}>
        <Grid item>
          <Button disabled={!props.enabled} variant={"outlined"} color={"primary"} onClick={props.onOpenModal}>
            {props.openModalLabel}
          </Button>
        </Grid>
      </Grid>
      <Dialog
        disableAutoFocus={true}
        disableEnforceFocus={true}
        disableRestoreFocus={true}
        disablePortal={true}
        open={props.isOpen}
        onClose={() => {
          props.onCloseModal()
          reset(INVOICE_INITIAL_STATE)
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <form onSubmit={handleSubmit(props.onSubmit)}>

          <DialogTitle id="alert-dialog-title">{props.dialogTitle}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {props.dialogDescription}
            </DialogContentText>

            <Grid container spacing={2}
                  direction={"row"}
                  alignContent={"center"}
                  justifyContent={"center"}
                  alignItems={"center"}>
              <Grid item xs={4}>
                <Controller
                  defaultValue={props.quote.reference}
                  name={"reference"}
                  render={({field, fieldState, formState}) => (
                    <TextField
                      {...field}
                      label={props.referenceLabel}
                      helperText={fieldState.error?.message}
                      error={!!(fieldState.invalid)}
                      fullWidth/>)
                  }
                  control={control}/>
              </Grid>
              <Grid item xs={4}>
                <Controller
                  name={"amountUntaxed"}
                  defaultValue={props.quote.amountUntaxed}

                  render={({field, fieldState, formState}) => (
                    <TextField
                      {...field}
                      label={props.amountUntaxedLabel}
                      type={"number"}
                      InputProps={{endAdornment: (<InputAdornment position="end">€</InputAdornment>)}}
                      helperText={fieldState.error?.message}
                      error={!!(fieldState.invalid)}
                      fullWidth/>)
                  }
                  control={control}/>
              </Grid>
              <Grid item xs={4}>
                <Controller
                  defaultValue={props.quote.amount}

                  name={"amount"}
                  render={({field, fieldState, formState}) => (
                    <TextField
                      {...field}
                      label={props.amountLabel}
                      type={"number"}
                      InputProps={{endAdornment: (<InputAdornment position="end">€</InputAdornment>)}}
                      helperText={fieldState.error?.message}
                      error={!!(fieldState.invalid)}
                      fullWidth/>)
                  }
                  control={control}/>
              </Grid>
              <Grid item xs={12}>

                <Grid container alignContent={"center"}
                      direction={'column'}
                      justifyContent={"center"}
                      alignItems={"center"}>
                  <Grid item xs={12}>
                    {props.quote.file && !props.quote.file.removed && props.quote.file.id ? (
                      <FileLink removable={true} key={props.quote.file.id} file={props.quote.file}/>) : ''}

                  </Grid>
                  <Grid item xs={12}>


                    <Dropzone
                      onDrop={onDrop}
                      noClick={!!quoteFile}
                      noKeyboard={!!quoteFile}
                      accept={['application/pdf']}
                    >
                      {({getRootProps, getInputProps}) => (
                        <Grid item xs={12} className={'bt-drop-zone'}>
                          <div {...getRootProps()}>
                            <p>{props.dropZoneLabel ? props.dropZoneLabel : 'Déposer Votre fichier ou cliquer ici'}</p>
                            <input {...getInputProps()} />
                          </div>
                        </Grid>
                      )}
                    </Dropzone>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button color="secondary" onClick={() => {
              props.onCloseModal()
              reset(INVOICE_INITIAL_STATE)
            }}>
              {props.dialogCancel ? props.dialogCancel : 'Annuler'}
            </Button>
            <Button autoFocus color="primary" type={"submit"} disabled={!props.quote.file}>
              {props.dialogSubmit ? props.dialogSubmit : 'Valider'}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>)
})`
  & .bt-drop-zone {
    flex: 1;
    width: 100%;
    height: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    border-width: 2px;
    border-radius: 2px;
    border-color: #eeeeee;
    border-style: dashed;
    background-color: #fafafa;
    color: #bdbdbd;
    outline: none;
    transition: border .24s ease-in-out;
  }

  & .bt-drop-zone:focus {
    border-color: #2196f3;
  }

`
